import usaStates from 'lib/settings/usa-states'

/**
 * Normalize a US state value to its 2-letter code.
 *
 * TAC (cruises-next) StateSelect matches on the uppercase 2-letter code, so a
 * full name ("Texas") or the wrong case silently blanks the dropdown. The
 * backend returns state inconsistently (mostly codes, occasionally a full name),
 * so normalize before handing it to the booking flow (GSE-11919).
 *
 * - a valid code (any case) → the uppercased code
 * - a full state name (any case) → its code
 * - empty / nullish → undefined
 * - anything unrecognized → the trimmed input unchanged
 */
export const normalizeStateToCode = (state?: string | null): string | undefined => {
  const trimmed = state?.trim()
  if (!trimmed) return undefined

  const upper = trimmed.toUpperCase()
  if (usaStates.some((s) => s.code === upper)) return upper

  const match = usaStates.find((s) => s.name.toLowerCase() === trimmed.toLowerCase())
  return match ? match.code : trimmed
}
